import { primitiveTokens, semanticThemeTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

export const screenshotSection = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["2x"]
});

export const screenshotActions = style({
  display: "flex",
  alignItems: "center",
  gap: primitiveTokens.sizing["2x"]
});

export const screenshotHint = style({
  opacity: 0.7,
  fontSize: primitiveTokens.type.xs
});

export const thumbnailRow = style({
  display: "flex",
  gap: primitiveTokens.sizing["2x"],
  flexWrap: "wrap"
});

export const thumbnail = style({
  position: "relative",
  width: "6rem",
  height: "4rem"
});

export const thumbnailImage = style({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: primitiveTokens.sizing["1x"],
  border: `1px solid ${semanticThemeTokens.divider.backgroundColor}`
});

export const thumbnailRemove = style({
  position: "absolute",
  top: `calc(-1 * ${primitiveTokens.sizing["2x"]})`,
  right: `calc(-1 * ${primitiveTokens.sizing["2x"]})`
});

export const hiddenFileInput = style({
  display: "none"
});

export const errorText = style({
  color: semanticThemeTokens.input.invalid.borderColor,
  fontSize: primitiveTokens.type.xs
});
